/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}
				this.classList.add('product-recommendations--loaded');

				initMobileFlickity();	
				function initMobileFlickity() {
				if (window.innerWidth > 768) return;

				var flickyMobile = document.querySelector('.product-recommendations ul.products');
				if (!flickyMobile) return;

				// If already initialized → destroy first
				if (flickyMobile.classList.contains('flickity-enabled')) {
					var existing = Flickity.data(flickyMobile);
					if (existing) existing.destroy();
				}

				// Wait one frame to ensure DOM is painted
				requestAnimationFrame(function () {
					console.log(flickyMobile);
					var flicky = new Flickity(flickyMobile, {
					cellAlign: "left",
					contain: true,
					prevNextButtons: false,
					pageDots: true,
					imagesLoaded: true,
					adaptiveHeight: false,
					});

					flicky.on('ready', function () {
					flicky.resize();
					console.log('Flickity loaded correctly');
					});
				});
				}
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
